'use client'

import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { getProfileAction } from '@/actions/user/get-profile-action'
import { useAuthStatus } from '@/hooks/use-auth-status'

// Data de lançamento da nova plataforma: 27 de março de 2025 às 3h da manhã (horário de Brasília)
const NEW_PLATFORM_LAUNCH_DATE = new Date('2025-08-27T03:00:00-03:00')

export function useNewPlatformModal() {
  const [shouldShowModal, setShouldShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const authStatus = useAuthStatus()

  useEffect(() => {
    async function checkUserRegistrationDate() {
      if (authStatus !== 'authenticated') {
        setIsLoading(false)
        return
      }

      try {
        const result = await getProfileAction()

        if ('data' in result && result.data?.data?.created_at) {
          const userCreatedAt = new Date(result.data.data.created_at)

          if (userCreatedAt > NEW_PLATFORM_LAUNCH_DATE) {
            setShouldShowModal(true)
          }
        }
      } catch {
        toast.error('Erro ao verificar data de cadastro')
      } finally {
        setIsLoading(false)
      }
    }

    checkUserRegistrationDate()
  }, [authStatus])

  const closeModal = () => {
    setShouldShowModal(false)
  }

  return {
    shouldShowModal,
    isLoading,
    closeModal,
  }
}
